/* TailBlaze — product gallery helper (runtime asset, never touches main-product.liquid):
   1) thumbnail strip shows 5 at a time with prev/next arrows (left hidden at start,
      right hidden at end, both in the middle) — paged via transform inside .slider__viewport;
   2) fixes the broken thumbnail click so it switches the main image (transform track inside
      .slider__viewport) and force-loads the target image.
   Re-applies on any (re)render (theme editor, section reloads) via a MutationObserver. */
(function () {
  var VISIBLE = 5, GAP = 10;

  var CSS = [
    '.tb-thumbs{position:relative;margin-top:22px !important;}',
    '.tb-thumbs .slider__viewport{overflow-x:auto !important;overflow-y:hidden !important;scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;scroll-snap-type:x proximity;scroll-behavior:smooth;}',
    '.tb-thumbs .slider__viewport::-webkit-scrollbar{display:none;}',
    '.tb-thumbs .thumbnail-list{display:flex !important;flex-wrap:nowrap !important;justify-content:flex-start !important;width:max-content !important;gap:' + GAP + 'px;padding:2px 0 !important;margin:0 !important;transform:none !important;}',
    '.tb-thumbs .thumbnail-list__item{flex-shrink:0 !important;margin:0 !important;aspect-ratio:1/1 !important;border-radius:50% !important;overflow:hidden !important;scroll-snap-align:start;}',
    '.tb-thumbs .thumbnail-list__item > a,.tb-thumbs .thumbnail-list__item > button,.tb-thumbs .thumbnail-list__item .card-js,.tb-thumbs .thumbnail-list__item .lazy-image-container{width:100% !important;height:100% !important;padding:0 !important;margin:0 !important;border-radius:50% !important;overflow:hidden !important;}',
    '.tb-thumbs .thumbnail-list__item figure,.tb-thumbs .thumbnail-list__item .lazy-image{width:100% !important;height:100% !important;border-radius:50% !important;overflow:hidden !important;margin:0 !important;}',
    '.tb-thumbs .thumbnail-list__item img{width:100% !important;height:100% !important;object-fit:cover !important;object-position:center center !important;background:#fff;}',
    '.tb-thumb-arrow{position:absolute;top:50%;transform:translateY(-50%);z-index:6;width:34px;height:34px;border-radius:999px;border:1.5px solid #140F3C;background:#fff;color:#140F3C;display:none;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 2px 10px rgba(20,15,60,.18);transition:background .15s ease,color .15s ease;padding:0;}',
    '.tb-thumb-arrow:hover{background:#140F3C;color:#fff;}',
    '.tb-thumb-arrow svg{width:17px;height:17px;display:block;}',
    '.tb-thumb-arrow--prev{left:-6px;}',
    '.tb-thumb-arrow--next{right:-6px;}',
    /* MOBILE main gallery: the theme positions slides via slider.scrollLeft, but the UL was
       not scrollable (overflow visible) — so thumbnail clicks and its own engine no-oped.
       Make it a real scroll-snap slider: clicks work AND finger-swipe works. */
    '@media (max-width: 989px){',
    'media-gallery .product__media-list.slider--mobile{overflow-x:auto !important;overflow-y:hidden !important;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;scrollbar-width:none;-ms-overflow-style:none;}',
    'media-gallery .product__media-list.slider--mobile::-webkit-scrollbar{display:none;}',
    'media-gallery .product__media-list.slider--mobile > li{scroll-snap-align:start;}',
    '}'
  ].join('');

  function injectStyle() {
    if (document.getElementById('tb-gallery-style')) return;
    var s = document.createElement('style');
    s.id = 'tb-gallery-style';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function arrow(dir) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'tb-thumb-arrow tb-thumb-arrow--' + dir;
    b.setAttribute('aria-label', dir === 'prev' ? 'Previous images' : 'Next images');
    b.innerHTML = dir === 'prev'
      ? '<svg viewBox="0 0 24 24" fill="none"><path d="M15 5l-7 7 7 7" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      : '<svg viewBox="0 0 24 24" fill="none"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    return b;
  }

  function initOne(list) {
    if (!list || list.dataset.tbGallery) return;
    var mg = list.closest('media-gallery') || document.querySelector('media-gallery');
    var thumbs = [].slice.call(list.querySelectorAll('.thumbnail-list__item'));
    if (!mg || thumbs.length < 2) return;
    list.dataset.tbGallery = '1';
    injectStyle();

    var track = mg.querySelector('.product__media-list');
    var mainItems = track ? [].slice.call(track.children) : [];
    var viewportEl = list.parentElement; // .slider__viewport (clips)

    var wrap = list.closest('.thumbnail-slider') || list.parentElement;
    wrap.classList.add('tb-thumbs');
    // remove any stale arrows (defensive) then add fresh ones
    [].forEach.call(wrap.querySelectorAll(':scope > .tb-thumb-arrow'), function (a) { a.remove(); });
    var prev = arrow('prev'), next = arrow('next');
    wrap.appendChild(prev); wrap.appendChild(next);

    /* native-scroll carousel: swipe/trackpad scroll works freely, arrows page by a
       full set of VISIBLE circles, snap keeps circles aligned. */
    var itemW = 0;
    function viewW() { return viewportEl.clientWidth || list.clientWidth; }
    function maxScroll() { return Math.max(0, viewportEl.scrollWidth - viewportEl.clientWidth); }
    function sizeThumbs() {
      itemW = Math.floor((viewW() - GAP * (VISIBLE - 1)) / VISIBLE);
      thumbs.forEach(function (t) {
        t.style.setProperty('flex', '0 0 ' + itemW + 'px', 'important');
        t.style.setProperty('width', itemW + 'px', 'important');
        t.style.setProperty('max-width', itemW + 'px', 'important');
        t.style.setProperty('height', itemW + 'px', 'important'); // square -> proper circle
        // the theme's .thumbnail button has horizontal padding that shrinks the image's
        // containing block — zero it so the image truly fills the circle
        var btn = t.querySelector('button, a');
        if (btn) {
          btn.style.setProperty('padding', '0', 'important');
          btn.style.setProperty('width', '100%', 'important');
          btn.style.setProperty('height', '100%', 'important');
        }
        // theme CSS (thumbnail--narrow/wide) forces img width:auto — inline !important wins,
        // so the image fills the circle, centered, whole image visible
        var img = t.querySelector('img');
        if (img) {
          img.style.setProperty('width', '100%', 'important');
          img.style.setProperty('height', '100%', 'important');
          img.style.setProperty('max-width', '100%', 'important');
          img.style.setProperty('max-height', '100%', 'important');
          img.style.setProperty('min-width', '100%', 'important');
          img.style.setProperty('object-fit', 'cover', 'important');
          img.style.setProperty('object-position', 'center', 'important');
          img.style.setProperty('padding', '0', 'important');
          img.style.setProperty('box-sizing', 'border-box', 'important');
        }
      });
    }
    function updateArrows() {
      var sl = viewportEl.scrollLeft;
      var tol = Math.max(12, Math.round(itemW / 3)); // snap can stop a few px short of the ends
      prev.style.display = sl > tol ? 'flex' : 'none';
      next.style.display = sl < maxScroll() - tol ? 'flex' : 'none';
    }
    function page(dir) {
      viewportEl.scrollBy({ left: dir * VISIBLE * (itemW + GAP), behavior: 'smooth' });
    }
    function ensureVisible(i) {
      var it = thumbs[i]; if (!it) return;
      var left = it.offsetLeft, right = left + it.offsetWidth;
      if (left < viewportEl.scrollLeft) viewportEl.scrollTo({ left: left, behavior: 'smooth' });
      else if (right > viewportEl.scrollLeft + viewW()) viewportEl.scrollTo({ left: right - viewW(), behavior: 'smooth' });
    }
    prev.addEventListener('click', function () { page(-1); }); // earlier circles
    next.addEventListener('click', function () { page(1); });  // later circles
    viewportEl.addEventListener('scroll', function () { requestAnimationFrame(updateArrows); }, { passive: true });

    sizeThumbs();
    requestAnimationFrame(updateArrows);
    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { sizeThumbs(); updateArrows(); }, 150); });

    // start flush-left, but only until the user interacts — after that their scroll wins
    var userTouched = false;
    ['pointerdown', 'wheel', 'touchstart'].forEach(function (ev) {
      viewportEl.addEventListener(ev, function () { userTouched = true; }, { passive: true });
    });
    // the theme's lazy-loader swaps <img> elements after init, wiping our inline styles —
    // re-assert sizing whenever an image loads, plus on a few timers (also re-pin to start
    // if the theme auto-scrolled the strip before any user interaction)
    list.addEventListener('load', function () { sizeThumbs(); }, true);
    [400, 900, 1800, 3200, 5000].forEach(function (ms) {
      setTimeout(function () {
        sizeThumbs();
        if (!userTouched && viewportEl.scrollLeft !== 0) viewportEl.scrollTo({ left: 0, behavior: 'auto' });
        updateArrows();
      }, ms);
    });

    /* fix click -> switch main image */
    function forceLoad(item) {
      if (!item) return;
      var img = item.querySelector('img');
      if (img && !img.complete) { img.setAttribute('loading', 'eager'); var s = img.getAttribute('src'); if (s) img.setAttribute('src', s); }
    }
    function mainScroller() {
      // mobile: the main gallery is a native scroll slider — find the element that actually scrolls
      var cands = [track, track && track.parentElement];
      for (var c = 0; c < cands.length; c++) {
        var el = cands[c];
        if (!el) continue;
        var ov = getComputedStyle(el).overflowX;
        if ((ov === 'auto' || ov === 'scroll') && el.scrollWidth > el.clientWidth + 10) return el;
      }
      return null;
    }
    function showMain(i) {
      var target = mainItems[i];
      forceLoad(mainItems[i - 1]); forceLoad(target); forceLoad(mainItems[i + 1]);
      // First let the theme's own switcher run (drives the touch swipe slider on phones);
      // then our scroller/transform fallback covers the desktop clipped-track mode where
      // the theme's scrollTo is a no-op. The two don't conflict: scroll targets are
      // absolute and the transform path only runs when nothing scrolls natively.
      try {
        var mid = target && target.getAttribute('data-media-id');
        if (mid && typeof mg.setActiveMedia === 'function') { mg.setActiveMedia(mid); }
      } catch (e) {}
      if (track && target) {
        var sc = mainScroller();
        if (sc) {
          // native slider (mobile): scroll it; clear any transform so they don't fight
          track.style.transform = '';
          var delta = target.getBoundingClientRect().left - sc.getBoundingClientRect().left;
          sc.scrollTo({ left: sc.scrollLeft + delta, behavior: 'smooth' });
        } else {
          // clipped transform track (desktop)
          track.style.transition = 'transform .3s ease';
          track.style.transform = 'translateX(' + (-target.offsetLeft) + 'px)';
        }
      }
      mainItems.forEach(function (m, k) { m.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      ensureVisible(i);
    }
    thumbs.forEach(function (th, i) { th.addEventListener('click', function () { showMain(i); }); });
    forceLoad(mainItems[1]);
  }

  function initAll() {
    [].forEach.call(document.querySelectorAll('.thumbnail-list'), function (l) {
      if (!l.dataset.tbGallery) initOne(l);
    });
  }

  var scheduled = false;
  function schedule() { if (scheduled) return; scheduled = true; setTimeout(function () { scheduled = false; initAll(); }, 120); }

  function start() {
    initAll();
    try {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) { if (muts[i].addedNodes && muts[i].addedNodes.length) { schedule(); return; } }
      }).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
    // a few retries for late hydration
    var n = 0, iv = setInterval(function () { initAll(); if (++n >= 12) clearInterval(iv); }, 350);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:select', schedule);
})();
